import { RequestTypes } from './Onboarding'

export enum ESpecializationStatus {
  wip = 'Wip',
  done = 'Done',
  contractWip = 'Contract WIP',
  contract = 'Contract',
  new = 'New',
  member = 'Member',
}

export enum ESpecializationMessageCode {
  isNotCommercialPoserOrPowerServiceMember = 'isNotCommercialPowerOrPowerServiceMember',
}

export interface IMainParam {
  code: string
  isActive: boolean
  name: string
  order: number
  request: {
    id: number
    type: RequestTypes
    spz?: string
    spzCode?: string
    requestUid?: string
  } | null
  status: ESpecializationStatus
  messageCode?: ESpecializationMessageCode
  isActiveCriteriaExist?: boolean
}
